module.exports = __webpack_public_path__ + "img/prosperity.4302d3e7.png";